"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPoint = exports.GeoPointConfig = exports.GeoPointFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const validators_1 = require("../../../validators");
exports.GeoPointFieldType = "GeoPoint";
exports.GeoPointConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
}));
exports.GeoPoint = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.GeoPointFieldType),
    }),
    t.partial({
        fieldset: validators_1.StringOrNull,
        config: exports.GeoPointConfig,
    }),
]));
